import React, {useEffect, useState} from 'react';
import {FaEdit, FaInfoCircle, FaSearch, FaTasks, FaUserCheck} from "react-icons/fa";
import {useWorkshop} from "../Common/WorkshopContext";
import {
    addEmployee,
    assignEmployeesToJobCard, deleteJobCard,
    getEmployeeForWorkshop,
    getJobCardsByWorkshopId,
    updateJobCardStatus,
} from "../../Api/Api";
import EditJobCardModal from "./EditJobcard";
import CreateJobCardModal from "./Createjobcard";
import JobCardDetailsModal from "./JobCardDetailsModal";
import AssignWorkerModal from "./AssignWorkerModal";
import UpdateJobStatusModal from "./UpdateJobStatusModal";
import Pagination from "../Pagination/Pagination";
import CreateJobCardModal2 from "./Createjobcard2";
import {useNotification} from "../Notification/NotificationContext";
import {Link} from "react-router-dom";
import DeleteJobCardModal from "./DeleteJobCardModal";

const JobCardsList = ({ }) => {
    const [jobCards, setJobCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('ALL');
    const { workshopId } = useWorkshop();
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedJobCard, setSelectedJobCard] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [showDetailsModal, setShowDetailsModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const pageSize = 10; // Define how many customers per page
    const { showNotification } = useNotification();

    const handleOpenAssignModal = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowAssignModal(true);
    };

    const handleCloseAssignModal = () => {
        setShowAssignModal(false);
    };

    const handleOpenStatusModal = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowStatusModal(true);
    };

    const handleOpenDetailsModal = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowDetailsModal(true);
    };
    const handleAssignEmployees = async (selectedEmployees) => {
        await assignEmployeesToJobCard(selectedJobCard.id, selectedEmployees);
        setShowAssignModal(false);
        fetchJobCards()// Refresh the list
    };

    useEffect(() => {
        fetchJobCards();
    }, [workshopId, statusFilter, pageSize, currentPage,searchTerm]);

    useEffect(() => {
        fetchEmployees();
    }, [workshopId]);

    const fetchEmployees = () => {
        getEmployeeForWorkshop(workshopId, 100,0)
            .then(response => {
                setEmployees(response.data.content); // Assuming response is an array of employee objects
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);

            });
    }

    const fetchJobCards = () => {
        setLoading(true);
            getJobCardsByWorkshopId(workshopId, statusFilter, pageSize, currentPage,searchTerm)
            .then((res) => {
                setJobCards(res.data.content); // Assuming API returns paginated content
                setTotalPages(res.data.totalPages);
                setTotalCount(res.data.totalElements);
            })
            .catch((error) => console.error('Error updating worktype:', error));
        setLoading(false);
    };

    const handleUpdateStatus = async (id, newStatus) => {
        try {
            updateJobCardStatus(id, newStatus)
                .then(response => {
                    setShowStatusModal(false);
                    fetchJobCards()// Refresh the list
                })
                .catch((error) => {
                    showNotification(error.message, "error")
                    setLoading(false);
                });
        }catch (error) {
            showNotification(error.message, "error")
        }


    };

    const handleEdit = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowEditModal(true);
    };
    const handleCloseModal = () => {
        setSelectedJobCard(null);
        setShowDetailsModal(false);
    };

    const handleOpenDeleteModal = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowDeleteModal(true);
    };

    const handleDeleteJobCard = async (id) => {
        try {
            await deleteJobCard(id);
            showNotification("Job card deleted successfully", "success");
            fetchJobCards();
        } catch (error) {
            showNotification(error.message || "Failed to delete job card", "error");
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div>
            <div className="mt-6">
                <div className=" max-w-screen-xl mx-auto">
                    <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                        <div className="bg-teal-400 text-white p-3 rounded-t-lg flex justify-between items-center">
                            <h2 className="text-xl font-semibold">Job Cards</h2>
                            <div className="flex gap-2 items-center w-full sm:w-auto">
                                <div className="relative w-full sm:w-64">
                                    <input
                                        type="text"
                                        placeholder="Search by name "
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="w-full pl-10 pr-4 py-2 rounded-md focus:outline-none text-gray-700"
                                    />
                                    <FaSearch className="absolute left-3 top-2.5 text-gray-400" />
                                </div>
                                <select
                                    className="border px-4 py-2 rounded-md text-gray-700 bg-white focus:outline-none"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="ALL">All</option>
                                    <option value="IN_PROGRESS">In Progress</option>
                                    <option value="COMPLETED">Completed</option>
                                    <option value="PENDING">Pending</option>
                                    <option value="CANCELLED">Cancelled</option>
                                    <option value="BILLED">Billed</option>
                                </select>
                            </div>

                        </div>
                        {jobCards && jobCards.length > 0 ? (
                        <div className="p-6">
                            <div className="overflow-x-auto shadow-md rounded-lg">
                                <table className="min-w-full bg-white">
                                    <thead className="bg-gray-50 text-gray-800">
                                    <tr>
                                        <th className="p-2 text-left">ID</th>
                                        <th className="p-2 text-left">Customer</th>
                                        <th className="p-2 text-left">Vehicle</th>
                                        <th className="p-2 text-left">Date</th>
                                        <th className="p-2 text-left">Status</th>
                                        <th className="p-2 text-left">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {jobCards.map((jobCard) => (
                                        <tr key={jobCard.id} className="border-b hover:bg-gray-100">
                                            <td className="p-2">{jobCard.id}</td>
                                            <td className="p-2 hover:underline">
                                                <Link to={`/customers/${jobCard.customer.id}/workshops/${workshopId}/profile`}> {jobCard.customer.name}</Link>

                                            </td>
                                            <td className="p-2">{jobCard.vehicleNumber}</td>
                                            <td className="p-2">{jobCard.createdAt}</td>
                                            <td className="p-2">
                                                <span
                                                    className={`px-2 py-1 rounded text-white ${
                                                        jobCard.status === "IN_PROGRESS"
                                                            ? "bg-yellow-500"
                                                            : jobCard.status === "COMPLETED"
                                                                ? "bg-green-500"
                                                                : "bg-gray-500"
                                                    }`}
                                                >
                                                    {jobCard.status}
                                                </span>
                                            </td>
                                            <td className="p-2 flex space-x-2">
                                                <td className="p-2 flex space-x-2">
                                                    <button
                                                        className="bg-blue-500 text-white px-3 py-1 rounded flex items-center hover:bg-blue-600 transition"
                                                        onClick={() => handleOpenDetailsModal(jobCard)}
                                                    >
                                                        <FaInfoCircle className="mr-1" /> Details
                                                    </button>

                                                    {jobCard.status !== 'COMPLETED' && jobCard.status !== 'BILLED' && (
                                                        <>
                                                            <button
                                                                className="bg-yellow-500 text-white px-3 py-1 rounded flex items-center hover:bg-yellow-600 transition"
                                                                onClick={() => handleEdit(jobCard)}
                                                            >
                                                                <FaEdit className="mr-1" /> Edit
                                                            </button>

                                                            <button
                                                                className="bg-purple-500 text-white px-3 py-1 rounded flex items-center hover:bg-purple-600 transition"
                                                                onClick={() => handleOpenAssignModal(jobCard)}
                                                            >
                                                                <FaUserCheck className="mr-1" /> Assign
                                                            </button>

                                                            <button
                                                                className="bg-green-500 text-white px-3 py-1 rounded flex items-center hover:bg-green-600 transition"
                                                                onClick={() => handleOpenStatusModal(jobCard)}
                                                            >
                                                                <FaTasks className="mr-1" /> Status
                                                            </button>

                                                            <button
                                                                className="bg-red-500 text-white px-3 py-1 rounded flex items-center hover:bg-red-600 transition"
                                                                onClick={() => handleOpenDeleteModal(jobCard)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </>
                                                    )}
                                                </td>

                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                                <div className="flex justify-start mt-2">
                                    <Pagination
                                        totalPages={totalPages}
                                        onPageChange={setCurrentPage}
                                        currentPage={currentPage}
                                        totalCount={totalCount}
                                    />
                                </div>
                        </div>
                        ) : (
                            <div className="text-center text-gray-600 py-10">
                                No Job Cards  found.
                            </div>
                        )}
                    </div>

                </div>

                <CreateJobCardModal2
                    show={showCreateModal}
                    handleClose={() => setShowCreateModal(false)}
                    fetchJobCards={fetchJobCards}
                />

                <EditJobCardModal
                    show={showEditModal}
                    handleClose={() => setShowEditModal(false)}
                    jobCardId={selectedJobCard?.id}
                    workshopId={workshopId}
                    onUpdate={() => fetchJobCards()}
                />

                <AssignWorkerModal show={showAssignModal} onClose={() => setShowAssignModal(false)} employees={employees} onAssign={handleAssignEmployees} />
                <UpdateJobStatusModal show={showStatusModal} onClose={() => setShowStatusModal(false)} jobCard={selectedJobCard} onUpdate={handleUpdateStatus} />
                <JobCardDetailsModal
                    show={showDetailsModal}
                    handleClose={handleCloseModal}
                    selectedJobCard={selectedJobCard}
                />

                <DeleteJobCardModal
                    show={showDeleteModal}
                    onClose={() => setShowDeleteModal(false)}
                    onConfirm={handleDeleteJobCard}
                    jobCard={selectedJobCard}
                />

            </div>
        </div>

    );
};

export default JobCardsList;